import React from 'react';
import Joyride from 'react-joyride';
import { useSpotlight } from './use-spotlight';
import { SpotlightTooltip } from './spotlight-tooltip-content';
import Confetti from 'react-confetti';
import useWindowSize from './use-get-window-size.tsx';

const CONFETTI_Z_INDEX = 10001;

const Spotlight = () => {
  const { width, height } = useWindowSize();
  const { steps, stepIndex, handleJoyrideCallback, runAllSpotlights } =
    useSpotlight();

  const hasSaluteStep =
    steps[stepIndex]?.showSalute &&
    document.querySelector(steps[stepIndex].target);

  return (
    <>
      {hasSaluteStep && (
        <Confetti
          width={width}
          height={height}
          style={{
            zIndex: CONFETTI_Z_INDEX,
          }}
          colors={['#E6332A', '#7490FF', '#31DE91', '#F1BF0B', '#8B5BF1']}
        />
      )}

      <Joyride
        steps={steps}
        run={runAllSpotlights}
        tooltipComponent={SpotlightTooltip}
        callback={handleJoyrideCallback}
      />
    </>
  );
};

export default Spotlight;
